
//React builder
import React, { useState } from "react";
import { BrowserRouter as Router, Link, Route, Switch, NavLink } from "react-router-dom";
import { Drawer, List, ListItem, ListItemText, AppBar, Toolbar, IconButton, Collapse, Typography, Container } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { FiHome } from "react-icons/fi";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import PostAddIcon from '@mui/icons-material/PostAdd';
// Company
import CompanyIndex from './components/pages/company/Index';
import CompanyCreate from "./components/pages/company/Create";
import CompanyEdit from "./components/pages/company/Edit";

// Branch
import BranchIndex from './components/pages/branch/Index';
import BranchCreate from "./components/pages/branch/Create";
import BranchEdit from "./components/pages/branch/Edit";

// Item Category
import ItemCategoryIndex from './components/pages/ItemCategory/Index';

//User
import UserIndex from "./components/pages/User/Index";
import UserCreate from "./components/pages/User/Create";
import UserEdit from "./components/pages/User/Edit";
import UserDetail from "./components/pages/User/Detail";
import PasswordChange from "./components/pages/User/PasswordChange";

//Role
import RoleIndex from "./components/pages/Role/Index";
import RoleDetail from "./components/pages/Role/Detail";

// Item 
import ItemIndex from './components/pages/Item/Index';
import ItemCreate from "./components/pages/Item/Create";
import ItemEdit from "./components/pages/Item/Edit";

//Master 
import MasterIndex from "./components/pages/Master/Index";
import AccountHeadEdit from "./components/pages/Master/AHDEdit";
import BKEdit from "./components/pages/Master/BankEdit";
import StaffEdit from "./components/pages/Master/StaffEdit";
import AssetEdit from "./components/pages/Master/AssetEdit";
import COSEdit from "./components/pages/Master/CSEdit";
import otherEdit from "./components/pages/Master/OtherEdit";
import CapitalEdit from "./components/pages/Master/CapitalEdit";

//Balance Sheet 
import BalanceSheetIndex from "./components/pages/BalanceSheet/Index";

//Purchase
import PurchaseCreate from "./components/pages/Purchase/Create";
import PurchaseIndex from "./components/pages/Purchase/Index";
import PurchaseDetails from "./components/pages/Purchase/Details";
import PurchaseEdit from "./components/pages/Purchase/Edit";

//Purchase Return
import PurchaseReturnCreate from "./components/pages/PurchaseReturn/Create";
import PurchaseReturnIndex from "./components/pages/PurchaseReturn/Index";
import PurchaseReturnDetails from "./components/pages/PurchaseReturn/Details";
import PurchaseReturnEdit from "./components/pages/PurchaseReturn/Edit";

//Purchase Report
// import PurchaseRegReport from "./components/pages/Report/PurchaseRegistration";
// import PurchaseReqReport from "./components/pages/Report/PurchaseReqReport";


//Sale
import SaleIndex from "./components/pages/Sale/Index";
import SaleCreate from "./components/pages/Sale/Create";
import SaleDraftDetails from "./components/pages/Sale/DraftDetails";
import SaleDraftEdit from "./components/pages/Sale/DraftEdit";
import SaleDetails from "./components/pages/Sale/Details";
import SaleEdit from "./components/pages/Sale/Edit";
// Sale Return
import SaleReturnIndex from "./components/pages/SaleReturn/Index";
import SaleReturnCreate from "./components/pages/SaleReturn/Create";
import SaleReturnDetails from "./components/pages/SaleReturn/Details";
import SaleReturnEdit from "./components/pages/SaleReturn/Edit";
// PaymentAndReceipt
import PaymentReceiptIndex from "./components/pages/PaymentReceipt/Index";
import PaymentReceiptCreate from "./components/pages/PaymentReceipt/Create";
import PaymentReceiptEdit from "./components/pages/PaymentReceipt/Edit";
import PaymentReceiptDetails from "./components/pages/PaymentReceipt/Details";
//JournalEntry
import JournelEntry from "./components/pages/JournalEntryPage/Create";
import JournelEntryIndex from "./components/pages/JournalEntryPage/Index";
import JournalEntryEdit from "./components/pages/JournalEntryPage/Edit";
import JournalEntryDetails from "./components/pages/JournalEntryPage/Details";

//Reports 
import Ledger from "./components/pages/Report/Ledger";
import CustomerDetails from "./components/pages/Report/CustomerDetails";
import Stock from "./components/pages/Report/Stock";
import CreditorDebitorReport from "./components/pages/Report/CreditorDebitor";
import CollectionReport from "./components/pages/Report/CollectionReport";
import Salegstreport from "./components/pages/Report/SaleGstReport";
import SaleRegister from "./components/pages/Report/SaleRegister";
import PurchaseRegisterReport from "./components/pages/Report/PurchaseRegistration";
import CashBook from "./components/pages/Report/CashBook";
//Company Logo
import CompanyLogo from '../src/components/pages/CompanyLogo/CompanyLogo.png';
//JK LOGO 
import JkLOGO from '../src/components/pages/JkLOGO/JK LOGO.png';
//Dress icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTshirt, faSuitcase } from '@fortawesome/free-solid-svg-icons'
import { Store, Business } from '@mui/icons-material';
import SummarizeIcon from '@mui/icons-material/Summarize';

// Using available icons//Home
import Home from "./components/pages/Home";

//Styles
import './stylesheet.css';
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.scss';
import './loding.scss';
import LodingComponent from "./loding";

//Auth
import { AuthProvider, useAuth } from "./AuthContext";

//Logout
import Logout from "./Logout";

//SessionTimeOut
import SessionTimeout from "./SessionTimeout";

//App Icons
import InventoryIcon from '@mui/icons-material/Inventory';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import StoreIcon from '@mui/icons-material/Store';
import CategoryIcon from '@mui/icons-material/Category';
import PersonIcon from '@mui/icons-material/Person';
import AnimationIcon from '@mui/icons-material/Animation';
import DeblurIcon from '@mui/icons-material/Deblur';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import SecurityIcon from '@mui/icons-material/Security';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import OutputIcon from '@mui/icons-material/Output';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { ShoppingCart } from '@mui/icons-material';
import RemoveShoppingCartIcon from '@mui/icons-material/RemoveShoppingCart';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import DescriptionIcon from '@mui/icons-material/Description';
import NoteIcon from '@mui/icons-material/Note';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import ArticleIcon from '@mui/icons-material/Article';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';

const App = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [masterOpen, setMasterOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);
  const [otherOpen, setOtherOpen] = useState(false);
  const [userOpen, setuserOpen] = useState(false);
  const [itemOpen, setItemOpen] = useState(false);

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleMasterClick = () => {
    setMasterOpen(!masterOpen);
  };

  const handleReportClick = () => {
    setReportOpen(!reportOpen);
  };

  const handleOtherClick = () => {
    setOtherOpen(!otherOpen);
  };


  const handleUserClick = () => {
    setuserOpen(!userOpen);
  };

  const handleItemClick = () => {
    setItemOpen(!itemOpen);
  };

  const { companyName, companyId, isSuperAdmin, superCompanyId, roleName, permissions } = useAuth();

  const hasReadMasterPermission = permissions.includes('Read Reports');


  return (
    <Router>
      <AuthProvider>
        <SessionTimeout />

        <AppBar position="static" style={{ backgroundColor: '#001F3F', height: '55px' }}>
          <Toolbar style={{ minHeight: '55px', padding: '0 24px', position: 'relative' }}>
            <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleDrawerOpen}>
              <MenuIcon />
            </IconButton>

            <Typography variant="h6" component="div" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
              <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                <Link to="/Home" style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center' }}>
                  <FiHome style={{ marginRight: '8px' }} />
                  <Typography variant="h5" className="dual-text" component="div" style={{ marginLeft: '16px', fontWeight: 'bolder', position: 'relative' }}>
                    {companyName}

                  </Typography>

                </Link>
              </div>
              <div className="white-icon" style={{ marginTop: '-5px' }}>
                <Logout />
              </div>
            </Typography>
          </Toolbar>
        </AppBar>

        <Drawer anchor="left" open={drawerOpen} onClose={handleDrawerClose}>

          <Typography
            variant="h5"
            component="div"
            sx={{
              fontFamily: '"Playfair Display", serif',
              fontWeight: '700',
              color: 'transparent',
              background: 'linear-gradient(to right, #1B1833, #1B1833)',
              WebkitBackgroundClip: 'text',
              textAlign: 'center',
              padding: '20px',
              textTransform: 'uppercase',
              letterSpacing: '2px',
              textShadow: '1px 1px 5px rgba(0, 0, 0, 0.3)',
              display: 'flex',
              marginLeft: '-0.90%'

            }}
          >
            <ShoppingBagIcon style={{ marginRight: '10px', color: 'teal' }} />
            {companyName}
          </Typography>

          <List>
            <ListItem button component={NavLink} to="/Home" activeClassName="selected" onClick={handleDrawerClose}>
              <ListItemText primary="HOME" />
            </ListItem>

            <ListItem button onClick={handleMasterClick}>
              <ListItemText primary="MASTER" />
              {masterOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>


            <Collapse in={masterOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px' }}>
                <ListItem button component={NavLink} to="/BranchIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <StoreIcon style={{ color: 'blueviolet', height: '20px' }} /><ListItemText primary="Branch" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/MasterIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <PersonIcon style={{ color: 'black' }} /> <ListItemText primary="Registration" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>
                <ListItem button component={NavLink} to="/BalanceSheetIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <DeblurIcon style={{ color: '#9B3922' }} /> <ListItemText primary="Balance Sheet" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/ItemCategoryIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <CategoryIcon style={{ color: 'darkolivegreen', height: '20px' }} /><ListItemText primary="Item Category" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/ItemIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <FormatListBulletedIcon style={{ color: '#134B70', height: '20px' }} /><ListItemText primary="Item" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>


              </List>
            </Collapse>

            <ListItem button onClick={handleItemClick}>
              <ListItemText primary="TRANSACTION" />
              {itemOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>


            <Collapse in={itemOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px' }}>

                <ListItem button component={NavLink} to="/PurchaseIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <InventoryIcon style={{ color: '#134B70', height: '20px' }} /><ListItemText primary="Purchase" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/PurchaseReturnIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <AssignmentReturnIcon style={{ color: 'darkolivegreen', height: '20px' }} /><ListItemText primary="Purchase Return" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/SaleIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <ShoppingBagIcon style={{ color: '#3B1C32', height: '20px' }} /><ListItemText primary="Sale" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/SaleReturnIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <RemoveShoppingCartIcon style={{ color: 'darkorange', height: '20px' }} /><ListItemText primary="Sale Return" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>
                <ListItem button component={NavLink} to="/PaymentReceiptIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <ReceiptLongIcon style={{ color: 'darkgreen', height: '20px' }} /><ListItemText primary="Payment And Receipt" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/JournelEntryIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <PostAddIcon style={{ color: 'darkblue', height: '20px' }} /><ListItemText primary="Journel Entry " style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

              </List>
            </Collapse>
            {hasReadMasterPermission && (
              <ListItem button onClick={handleReportClick}>
                <ListItemText primary="REPORT" />
                {reportOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
            )}

            <Collapse in={reportOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px' }}>

                <ListItem button component={NavLink} to="/CustomerDetails" activeClassName="selected" onClick={handleDrawerClose}>
                  <PersonIcon style={{ color: 'black', height: '20px' }} /> <ListItemText primary="Customer Details" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/Ledger" activeClassName="selected" onClick={handleDrawerClose}>
                  <InventoryIcon style={{ color: 'blueviolet', height: '20px' }} /><ListItemText primary="Ledger" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/CashBook" activeClassName="selected" onClick={handleDrawerClose}>
                  <CurrencyRupeeIcon style={{ color: 'blue#9B3922violet', height: '20px' }} /><ListItemText primary="Cash Book" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>


                <ListItem button component={NavLink} to="/Stock" activeClassName="selected" onClick={handleDrawerClose}>
                  <SummarizeIcon style={{ color: 'darkorange', height: '20px' }} /><ListItemText primary="Stock" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/CreditorDebitorReport" activeClassName="selected" onClick={handleDrawerClose}>
                  <SummarizeIcon style={{ color: 'darkolivegreen', height: '20px' }} /><ListItemText primary="Creditors/Debitors" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/CollectionReport" activeClassName="selected" onClick={handleDrawerClose}>
                  <DescriptionIcon style={{ color: 'darkblue', height: '20px' }} /><ListItemText primary="Collection Summary" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/PurchaseRegisterReport" activeClassName="selected" onClick={handleDrawerClose}>
                  <NoteIcon style={{ color: '#3B1C32', height: '20px' }} /><ListItemText primary="Purchase Register" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/SaleGstReport" activeClassName="selected" onClick={handleDrawerClose}>
                  <TextSnippetIcon style={{ color: 'darkblue', height: '20px' }} /><ListItemText primary="Sale GST Report" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/SaleRegister" activeClassName="selected" onClick={handleDrawerClose}>
                  <ArticleIcon style={{ color: '#134B70', height: '20px' }} /><ListItemText primary="Sale Register" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

              </List>
            </Collapse>

            <ListItem button onClick={handleUserClick}>
              <ListItemText primary="USER" />
              {userOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={userOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px' }}>

                {roleName == "SuperAdmin" && (

                  <ListItem button component={NavLink} to="/UserIndex" activeClassName="selected" onClick={handleDrawerClose}>
                    <PeopleAltIcon style={{ color: 'blueviolet', height: '20px' }} /><ListItemText primary="User" style={{ marginLeft: '3px' }} />
                  </ListItem>
                )}

                {roleName == "SuperAdmin" && (
                  <ListItem button component={NavLink} to="/RoleIndex" activeClassName="selected" onClick={handleDrawerClose}>
                    <AccessibilityIcon style={{ color: 'darkorange', height: '20px' }} /><ListItemText primary="Role" style={{ marginLeft: '3px' }} />
                  </ListItem>
                )}

                <ListItem button component={NavLink} to="/PasswordChange" activeClassName="selected" onClick={handleDrawerClose}>
                  <SecurityIcon style={{ color: 'darkolivegreen', height: '20px' }} /><ListItemText primary="Change Password" style={{ marginLeft: '3px' }} />
                </ListItem>
              </List>
            </Collapse>

          </List>
        </Drawer>


        <Container maxWidth="xl">
          <Switch>

            <Route path="/" exact component={Home} />
            <Route path="/Home" exact component={Home} />

            {/* Company */}
            <Route path="/CompanyIndex" component={CompanyIndex} />
            <Route path="/CompanyCreate" component={CompanyCreate} />
            <Route path="/CompanyEdit/:id" component={CompanyEdit} />

            {/* Branch */}
            <Route path="/BranchIndex" component={BranchIndex} />
            <Route path="/BranchCreate" component={BranchCreate} />
            <Route path="/BranchEdit/:id" component={BranchEdit} />

            {/* User */}
            <Route path="/UserIndex" component={UserIndex} />
            <Route path="/UserCreate" component={UserCreate} />
            <Route path="/UserEdit/:id" component={UserEdit} />
            <Route path="/UserDetail/:id" component={UserDetail} />
            <Route path="/PasswordChange" component={PasswordChange} />

            {/* Role */}
            <Route path="/RoleIndex" component={RoleIndex} />
            <Route path="/RoleDetail/:id" component={RoleDetail} />

            {/* Item Category */}
            <Route path="/ItemCategoryIndex" component={ItemCategoryIndex} />

            {/* Item  */}
            <Route path="/ItemIndex" component={ItemIndex} />
            <Route path="/ItemCreate" component={ItemCreate} />
            <Route path="/ItemEdit/:id" component={ItemEdit} />

            {/* Master  */}
            <Route path="/MasterIndex" component={MasterIndex} />
            {/* Masteredit id as masterId and mtypeid as masterTypeid  */}
            <Route path="/AccountHeadEdit/:id/:Mtypeid" component={AccountHeadEdit} />
            <Route path="/AssetEdit/:id/:Mtypeid" component={AssetEdit} />
            <Route path="/BKEdit/:id/:Mtypeid" component={BKEdit} />
            <Route path="/StaffEdit/:id/:Mtypeid" component={StaffEdit} />
            <Route path="/CapitalEdit/:id/:mid" component={CapitalEdit} />
            {/* <Route path="/otherEdit/:id/Mtypeid" component={otherEdit} /> */}
            <Route path="/COSEdit/:id/:Mtypeid" component={COSEdit} />

            {/* BalanceSheet  */}
            <Route path="/BalanceSheetIndex" component={BalanceSheetIndex} />

            {/* Purchase */}
            <Route path="/PurchaseCreate" component={PurchaseCreate} />
            <Route path="/PurchaseIndex" component={PurchaseIndex} />
            <Route path="/PurchaseDetails/:id" component={PurchaseDetails} />
            <Route path="/PurchaseEdit/:id" component={PurchaseEdit} />

            {/* Purchase Return*/}
            {/* <Route path="/PurchaseReturnCreate/:id" component={PurchaseReturnCreate} /> */}
            <Route path="/PurchaseReturnCreate" component={PurchaseReturnCreate} />
            <Route path="/PurchaseReturnIndex" component={PurchaseReturnIndex} />
            <Route path="/PurchaseReturnDetails/:id" component={PurchaseReturnDetails} />
            <Route path="/PurchaseReturnEdit/:id" component={PurchaseReturnEdit} />


            {/* Sale */}
            <Route path="/SaleIndex" component={SaleIndex} />
            <Route path="/SaleCreate" component={SaleCreate} />
            <Route path="/SaleDraftDetails/:id" component={SaleDraftDetails} />
            <Route path="/SaleDraftEdit/:id" component={SaleDraftEdit} />
            <Route path="/SaleDetails/:id" component={SaleDetails} />
            <Route path="/SaleEdit/:id" component={SaleEdit} />
            {/* Sale Retrn*/}
            <Route path="/SaleReturnIndex" component={SaleReturnIndex} />
            <Route path="/SaleReturnCreate" component={SaleReturnCreate} />
            <Route path="/SaleReturnDetails/:id" component={SaleReturnDetails} />
            <Route path="/SaleReturnEdit/:id" component={SaleReturnEdit} />
            {/* Purchase Reports */}
            {/* <Route path="/PurchaseRegReport" component={PurchaseRegReport} />
            <Route Path="/PurchaseReqReport" component={PurchaseReqReport} /> */}
            {/* PaymentAndReceipt */}
            <Route path="/PaymentReceiptIndex" component={PaymentReceiptIndex} />
            <Route path="/PaymentReceiptCreate" component={PaymentReceiptCreate} />
            <Route path="/PaymentReceiptEdit/:id" component={PaymentReceiptEdit} />
            <Route path="/PaymentReceiptDetails/:id" component={PaymentReceiptDetails} />
            {/* JournalEntry */}
            <Route path="/JournelEntry" component={JournelEntry} />
            <Route path="/JournelEntryIndex" component={JournelEntryIndex} />
            <Route path="/JournalEntryEdit/:id" component={JournalEntryEdit} />
            <Route path="/JournalEntryDetails/:id" component={JournalEntryDetails} />
            {/* Report */}
            <Route path="/Ledger" component={Ledger} />
            <Route path="/CustomerDetails" component={CustomerDetails} />
            <Route path="/Stock" component={Stock} />
            <Route path="/CreditorDebitorReport" component={CreditorDebitorReport} />
            <Route path="/CollectionReport" component={CollectionReport} />
            <Route path="/Salegstreport" component={Salegstreport} />
            <Route path="/SaleRegister" component={SaleRegister} />
            <Route path="/PurchaseRegisterReport" component={PurchaseRegisterReport} />
            <Route path="/CashBook" component={CashBook} />

          </Switch>
        </Container>


      </AuthProvider >
    </Router>
  );
};

export default App;

